import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectEntityReferenceCandidatesByType } from 'store/loanApplications/selectors';

import { resolvePastedEntityReference } from '../../../TeamChat.entityUrl.utils';
import { getApplicationIdFromChannelId } from '../../../TeamChat.utils';

// Paste-to-alias works on both of a loan's channels (internal + TPO, DEV-5697) —
// getApplicationIdFromChannelId returns null for non-loan channels, so resolvePastedEntityReference
// (which requires the applicationId to match) naturally leaves DM pastes untouched. Candidates are
// already loaded by the picker hook living in the same composer, so no separate fetch is needed here.
const useChatEntityPaste = ({ chatId }) => {
  const applicationId = getApplicationIdFromChannelId(chatId);
  const candidatesByType = useSelector(selectEntityReferenceCandidatesByType);

  return useCallback(
    rawText => resolvePastedEntityReference({ rawText, applicationId, candidatesByType }),
    [applicationId, candidatesByType],
  );
};

export default useChatEntityPaste;
